import apiClient from 'api/config/apiClient'

export default {
  getDebtNotice(identifier) {
    return apiClient.request('cache-disable/debt_notice', { identifier })
  },
  getDebtNoticeFinancialResponsible(identifier) {
    return apiClient.request('cache-disable/debt_notice_financial_responsible', { identifier })
  },
  registerDebtNoticeRead(input) {
    return apiClient.request('cache-disable/debt_notice_read_receipt', { input })
  }
}
